'use strict'

# UserAgent
_ua = do ->
  IE = document.uniqueID
  ltIE6 = typeof window.addEventListener is undefined and typeof document.documentElement.style.maxHeight is undefined
  ltIE7 = typeof window.addEventListener is undefined and typeof document.querySelectorAll is undefined
  ltIE8 = typeof window.addEventListener is undefined and typeof document.getElementsByClassName is undefined
  ltIE9 = IE and typeof window.Worker is undefined
  IE6 = IE and ltIE6
  IE7 = IE and ltIE7 and not ltIE6
  IE8 = IE and ltIE8 and not ltIE7 and not ltIE6
  IE9 = IE and ltIE9 and not ltIE8 and not ltIE7 and not ltIE6
  IE10 = IE and not ltIE9 and not ltIE8 and not ltIE7 and not ltIE6
  Webkit = not document.uniqueID and not window.opera and not window.sidebar and not window.orientation and window.localStorage
  Safari = Webkit and navigator.vendor.search(/apple/i) isnt -1
  Chrome = Webkit and navigator.vendor.search(/google/i) isnt -1

  return {
    IE:IE,
    ltIE6:ltIE6,
    ltIE7:ltIE7,
    ltIE8:ltIE8,
    ltIE9:ltIE9,
    IE6:IE6,
    IE7:IE7,
    IE8:IE8,
    IE9:IE9,
    IE10:IE10,
    Firefox:window.sidebar,
    Opera:window.opera,
    Webkit:Webkit,
    Safari:Safari,
    Chrome:Chrome,
    Mobile:window.orientation
  }

# URL
url = do ->
  href = location.href.split('/')

  localRegex = /^\d+\.\d+\.\d+\.\d+/
  workRegex = /^.*\/pc\/[^\/]+\/.*$/

  for val , i in href
    if val is '' or i is href.length - 1 and val.indexOf('.')
      href.splice(i,1)

  if localRegex.test(location.hostname) is true or location.hostname.indexOf('localhost') isnt -1
    length = 2

  else if workRegex.test(location.href) is true
    length = 3

    for val , i in href
      if val is 'pc' and href[i-1] is 'work'
        length = 4

  else
    length = 1

  path = ''

  for j in [0..(length)]
    path += href[j]

    if j is 0
      path += '//'

    else
      path += '/'

  return path

# スムーススクロール関数モーション定義
jQuery.extend(
  jQuery.easing,{
    easeInOutCirc:
      (x, t, b, c, d) ->
        if (t/=d/2) < 1
          return -c/2 * (Math.sqrt(1 - t*t) - 1) + b
        c/2 * (Math.sqrt(1 - (t-=2)*t) + 1) + b
  }
)

window.onpageshow = (evt) ->
  if evt.persisted
    location.reload()
  return

event = {
  all: 'mousedown touchstart pointerdown mouseenter mouseleave'
  type: ''
  start: ''
  enter: ''
  leave: ''
  move: ''
  end: ''
}
# イベント判定

event.check = (e) ->
  _default = e.type
  event.start = _default
  event.move = if _default is 'pointerdown' then 'pointermove' else if _default is 'touchstart' then 'touchmove' else 'mousemove'
  event.end = if _default is 'pointerdown' then 'pointerup' else if _default is 'touchstart' then 'touchend' else 'click'
  event.enter = if _default is 'pointerenter' then _default else if _default is 'touchenter' then _default else 'mouseenter'
  event.leave = if _default is 'pointerleave' then _default else if _default is 'touchleave' then _default else 'mouseleave'
  return

event.on = (type, elm, fn, delegate) ->
  $(document).off(event.all, elm).on(event.all, elm, (e) ->
    e.preventDefault()
    event.check(e)
    if fn isnt null
      if e.type is event.enter or e.type is event.leave
        # mouseenter mouseleaveのとき、コールバック関数を即実行
        fn(this, e)
      else
        if type is 'bind'
          # jQuery $(element).on(event, func);
          $(elm).off(event.end).on(event.end, (e) ->
            fn(this, e)
            return
          )
        else if type is 'live'
          # jQuery $(document).on(event, element, func);
          $(document).off(event.end, elm).on(event.end, elm, (e) ->
            fn(this, e)
            return
          )
        else if type is 'delegate'
          # jQuery $(parentsElement).on(event, element, func);
          $(delegate).off(event.end, elm).on(event.end, elm, (e) ->
            fn(this, e)
            return
          )
    else
      # 引数にコールバック関数が定義されていないときの処理
    return
  )
  return


$(()->
  $id = $('body').attr('id')
  $class = $('body').attr('class')

  # topBtn = $('.pagetop')
  # #最初はボタンを隠す
  # topBtn.hide()
  # #スクロールが300に達したらボタンを表示させる
  # $(window).scroll(->
  #   if $(this).scrollTop() > 300
  #     topBtn.fadeIn()
  #   else
  #     topBtn.fadeOut()
  #   return
  # )
  #
  # topBtn.click(->
  #   $('body,html').animate({
  #     scrollTop: 0
  #   }, 500
  #   )
  #   return false
  # )

  # トップへ戻るボタン
  # $window = $(window)
  # $pagetop =$('.js-pagetop')
  #
  # $(window).scroll(
  #   ()->
  #     if $(this).scrollTop() > $(this).height()
  #       if not $pagetop.hasClass('is-active')
  #         $pagetop.addClass('is-active')
  #         $pagetop.addClass('is-animated')
  #     else
  #       if $pagetop.hasClass('is-active') and $pagetop.hasClass('is-animated')
  #         $pagetop.removeClass('is-animated')
  #
  #     $pagetop.on('oTransitionEnd mozTransitionEnd webkitTransitionEnd transitionend',
  #       ()->
  #         if $window.scrollTop() > $window.height()
  #           $pagetop.addClass('is-animated')
  #         else
  #           $pagetop.removeClass('is-active')
  #     )
  # )

  # スムーススクロール
  smoothScroll = ($target) ->
    $('body,html').animate({
      scrollTop: $($target.attr('href')).offset().top
    }, 500
    )
    false

  $('a[href^="#"]'+'a[href!="#"]').not('.js-tab-item a[href^="#"]').on('click.smoothScroll'
    (e)->
      e.preventDefault()
      smoothScroll($(this))

      return
  )

  # フリックかタッチか判別
  touchPos = 0
  threshold = 10
  isFlick = false

  $('.js-tab-item a[href^="#"]').on('focus',
    (e)->
      $(this).off('click.smoothScroll')
  )

  $('.js-tab-item a[href^="#"]').on('click',
    (e)->
      $parent = $(this).closest('.js-tab-box')
      e.preventDefault()
      $parent.find('.js-tab-item').removeClass('is-active')
      $(this).parent().addClass('is-active')
      $parent.find('.js-tab-box-contents').removeClass('is-active')
      $($(this).attr('href')).addClass('is-active')
  )

  $('.js-accordion-title').on('touchstart',
    (e)->
      isFlick = false
      touchPos = e.originalEvent.touches[0].pageY
  )

  $('.js-accordion-title').on('touchmove',
    (e)->
      currentPos = e.originalEvent.touches[0].pageY

      if Math.abs(touchPos - currentPos) > threshold
        isFlick = true
      else
        isFlick = false
  )

  # アコーディオン
  $('.js-accordion-title').on('touchend',
    ()->
      if not isFlick
        $parent = $root = $(this).closest('.js-accordion')
        $parent.removeClass('is-close')
        $parent.toggleClass('is-open')
        parentContentsHeight = rootContentsHeight = $parent.find('> .js-accordion-contents > .js-accordion-contents-inner').outerHeight()

        if $parent.hasClass('is-open')
          $parent.find('> .js-accordion-contents').css({
            'height': parentContentsHeight
            'maxHeight': parentContentsHeight
          })
        else
          $parent.find('> .js-accordion-contents').removeAttr('style')

        if $parent.hasClass('is-open-all')
          $parent.toggleClass('is-open-all')
          $parent.addClass('is-close-all')
        else if $parent.hasClass('is-close-all')
          $parent.toggleClass('is-close-all')
          $parent.addClass('is-open-all')

        if $parent.hasClass('js-subaccordion')
          $root = $parent.parents('.js-accordion')
          rootContentsHeight = $root.find('> .js-accordion-contents > .js-accordion-contents-inner').outerHeight()

          if $root.hasClass('is-open') and $parent.hasClass('is-open')
            $root.addClass('is-open-all')
          else
            $root.removeClass('is-open-all')

          if $root.hasClass('is-open')
            if $root.hasClass('is-open-all')
              allContentsHeight = if parentContentsHeight isnt rootContentsHeight then rootContentsHeight + parentContentsHeight else parentContentsHeight
            else
              allContentsHeight = if parentContentsHeight isnt rootContentsHeight then rootContentsHeight - parentContentsHeight else parentContentsHeight

            $root.find('> .js-accordion-contents').removeAttr('style')
            $root.find('> .js-accordion-contents').css({
              'height': allContentsHeight
              'maxHeight': allContentsHeight
            })

        $parent.on('oTransitionEnd mozTransitionEnd webkitTransitionEnd transitionend',
          ()->
            if not $parent.hasClass('is-open')
              $parent.addClass('is-close')
        )
  )

  $svgs = $('#m-clinic-logo')
  $svgs.addClass('is-inactive')

  # SVG 色変え
  $.each($svgs,
    (key, val)->
      $svg = $(val.contentDocument)
      $svg.find('path').css('fill', '#4f4737')
      $(val).removeClass('is-inactive')
      $(val).addClass('is-active')
  )

  # $(window).on('load',
  #   ()->
  #     # SVG 色変え
  #     $.each($svgs,
  #       (key, val)->
  #         $svg = $(val.contentDocument)
  #         console.log($svg.find('path'))
  #         $svg.find('path').css('fill', '#4f4737')
  #         $(val).removeClass('is-inactive')
  #         $(val).addClass('is-active')
  #     )
  #
  #     # フォーム同一ウィンドウ表示
  #     # $('.m-cv').find('.monitor, .inquiry').find('a').on('click',
  #     #   (e)->
  #     #     $(window).trigger('touchmove.noScroll')
  #     # )
  #     #
  #     # $(window).on('touchmove.noScroll',
  #     # (e)->
  #     #   if $('body').hasClass('is-fixed')
  #     #     e.preventDefault()
  #     # )
  # )

  # $('#m-lead-slide').slick({
  #   autoplay: true
  #   autoplaySpeed: 0
  #   speed: 7000
  #   dots: false
  #   arrows: false
  #   centerMode: true
  #   cssEase: 'linear'
  # })

  # 続きを読む
  # $('.js-readmore').on('click',
  #   ()->
  #     $(this).addClass('is-active')
  # )

  # もっと読む
  # showNum = 3
  # clickCount = 0

  # $('.js-loadmore-button').on('click',
  #   ()->
  #     clickCount++
  #     shownItemLength = $('.js-loadmore-contents.is-active').length

  #     $('.js-loadmore-contents').not('.is-active').each(
  #       ()->
  #         if $(this).index() < shownItemLength + showNum
  #           $(this).addClass('is-active')

  #         if shownItemLength + showNum >= $('.js-loadmore-contents').length
  #           $('.js-loadmore-button').removeClass('is-active')
  #     )

  #     currentHeight = 0
  #     $('.js-loadmore-contents.is-active').each(
  #       ()->
  #         currentHeight += $(this).outerHeight(true)
  #     )

  #     $('.js-loadmore-inner').css({
  #       'height': currentHeight
  #       'maxHeight': currentHeight
  #     })
  # )

  # 続きを読むがある場合
  # if $('.js-loadmore').hasClass('has-readmore')
  #   $('.js-readmore').on('click',
  #     ()->
  #       currentHeight = 0
  #       $('.js-loadmore-contents.is-active').each(
  #         ()->
  #           currentHeight += $(this).outerHeight(true)
  #       )

  #       $('.js-loadmore-inner').css({
  #         'height': currentHeight
  #         'maxHeight': currentHeight
  #       })
  #   )


  # $('#m-flow-pic-slide').slick({
  #   # autoplay: true
  #   infinite: false
  #   dots: false
  #   arrows: false
  #   centerMode: true
  #   centerPadding: 0
  #   variableWidth: true
  #   waitForAnimate:false
  #   asNavFor: '#m-flow-contents-slide'
  # })

  # $('#m-flow-contents-slide').slick({
  #   # autoplay: true
  #   infinite: false
  #   fade: true
  #   dots: false
  #   arrows: false
  #   waitForAnimate:false
  #   asNavFor: '#m-flow-pic-slide'
  # })

  # $('#m-flow-contents-slide').on('afterChange',
  #   (event, slick, currentSlide, nextSlide)->
  #     # if currentSlide is 0
  #     #   setTimeout(
  #     #     ()->
  #     #       console.log('play')
  #     #       $('#m-flow-pic-slide').slick('slickPlay')
  #     #       $('#m-flow-contents-slide').slick('slickPlay')
  #     #   , 1500
  #     #   )
  #     #
  #     # if currentSlide is 1
  #     #   setTimeout(
  #     #     ()->
  #     #       console.log('play')
  #     #       $('#m-flow-pic-slide').slick('slickGoTo', 2, false)
  #     #       $('#m-flow-contents-slide').slick('slickGoTo', 2, false)
  #     #   , 3000
  #     #   )

  #     if currentSlide is 2
  #       $('#m-flow-pic-slide').slick('slickPause')
  #       $('#m-flow-contents-slide').slick('slickPause')
  #       # setTimeout(
  #       #   ()->
  #       #     $('#m-flow-pic-slide').slick('slickGoTo', 0, false)
  #       #     $('#m-flow-contents-slide').slick('slickGoTo', 0, false)
  #       # , 3000
  #       # )
  # )

  # $('.l-fix-cv').headroom({
  #   offset: $(window).height()
  #   onPin: ()->
  #   onUnpin: ()->
  #   onTop: ()->
  #   onNotTop: ->
  # })


  # タブ
  # $('.js-tab-item a[href^="#"]').bind('touchend',
  #   (e)->
  #     e.preventDefault()
  #     $parent = $(this).parents('.js-tab-box')
  #     $parent.find('.js-tab-item').removeClass('is-active')
  #     $(this).parent().addClass('is-active')
  #     $parent.find('.js-tab-contents-item').removeClass('is-active')
  #     $($(this).attr('href')).addClass('is-active')
  # )

  # フォーム同一ウィンドウ表示
  # $('[class*=-cv]').find('.monitor, .inquiry').find('a').on('click',
  #   (e)->
  #     e.preventDefault()
  #     console.log('click1')
  #     $('body').addClass('is-fixed')
  #
  #     targetClass = $(this).parent().attr('class')
  #
  #     if targetClass.indexOf('monitor') isnt -1
  #       formPage = 'monitor'
  #     else if targetClass.indexOf('mail') isnt -1 or  targetClass.indexOf('inquiry') isnt -1
  #       formPage = 'inquiry'
  #
  #     $('#m-form').addClass('is-active')
  #     $('.m-form-inner').attr('src', formPage+'/')
  # )

  # フッター固定 CV
  # firstUpFlg = false
  # firstDownFlg = true
  #
  # $('.m-fix-cv').headroom({
  #   tolerance: {
  #     up:0
  #     down:5
  #   },
  #   offset:0
  #   onPin: ()->
  #     firstUpFlg = true
  #     if not firstDownFlg
  #       $('.m-fix-cv').removeClass('slideUpFirst')
  #   onUnpin: ()->
  #     $('.m-fix-cv').removeClass('slideUpFirst headroom--unpinned')
  #   onTop: ()->
  #     firstDownFlg = true
  #     $('.m-fix-cv').removeClass('headroom--pinned')
  #   onNotTop: ->
  #     if firstDownFlg
  #       $('.m-fix-cv').addClass('slideUpFirst')
  #       firstDownFlg = false
  # })

  # parallax = ($target)->
  #   $(window).scroll(
  #     ()->
  #       if $(window).scrollTop() > $target.position().top + $target.find('.m-contents-title').height() and
  #       $(window).scrollTop() <= $target.position().top + $target.outerHeight(true)
  #         $target.addClass('is-fixed')
  #       else
  #         $target.removeClass('is-fixed')
  #   )

  # $gnavi =$('.l-fix-cv')
  # $gnaviItem =$('.l-fix-cv-item')
  # $navContents = $('.js-nav-point')
  # navContentsPos = {}

  # $navContents.each(
  #   (index, val)->
  #     if $(this).attr('id')
  #       position = {}
  #       position[$(this).attr('id')] = $(this).offset().top
  #       navContentsPos[Object.keys(navContentsPos).length] = position
  # )

  # $(window).scroll(
  #   ()->
  #     $.each(navContentsPos,
  #       (key, val)->
  #         target = Object.keys(val)
  #         $target = $('#'+target)

  #         if $(window).scrollTop() + $(window).height() >= $target.position().top and
  #         $(window).scrollTop() + $(window).height() < $target.position().top + $target.outerHeight(true)
  #           $gnavi.find('.'+target).addClass('is-active')
  #           $gnaviItem.not('.'+target).removeClass('is-active')
  #           $('.l-fix-tel').removeClass('is-active')

  #         if $(window).scrollTop() + $(window).height() < $($navContents.get(0)).position().top
  #           $gnaviItem.removeClass('is-active')
  #           $('.l-fix-tel').removeClass('is-active')
  #     )
  # )

  # $('.l-fix-cv-item').find('a').on('touchstart',
  #   (e)->
  #     $(this).off('click.smoothScroll')
  # )

  # $('.l-fix-cv-item').find('a').on('click',
  #   (e)->
  #     if $(this).attr('href').indexOf('#') isnt -1
  #       e.preventDefault()

  #       if not $(this).parent().hasClass('is-active')
  #         $(this).one('click.smoothScroll', smoothScroll($(this)))
  # )

  # $('.m-safety-open').on('touchend',
  #   ()->
  #     $parent = $(this).closest('.m-safety')
  #     $parent.addClass('is-open')
  #     $(this).addClass('is-open')
  # )

  # $('.tel').on('click',
  #   (e)->
  #     if not $('.l-fix-tel').hasClass('is-active')
  #       $('.l-fix-cv-item').removeClass('is-active')
  #       $(this).addClass('is-active')
  #       $('.l-fix-tel').addClass('is-active')
  #     else
  #       $(this).removeClass('is-active')
  #       $('.l-fix-tel').removeClass('is-active')
  # )

  safeAreaInsetTop = 0
  safeAreaInsetLeft = 0
  safeAreaInsetRight = 0
  safeAreaInsetBottom = 0

  isSafeAreaDisplay = ()->
    flag = false

    # //constant()はiOS 11.2で削除されるのでenv()へのフォールバックが必要
    # //Designing Websites for iPhone X | WebKit
    # //https://webkit.org/blog/7929/designing-websites-for-iphone-x/
    isSafeAreaConst = CSS.supports('padding-left: constant(safe-area-inset-left)')
    isSafeAreaEnv = CSS.supports('padding-left: env(safe-area-inset-left)')

    # //どちらかがサポートされているなら実際の値を計算
    if isSafeAreaConst or isSafeAreaEnv
      # //safe-area-inset-*をダミーDIVのpaddingに設定する
      elmDiv = document.createElement('div')
      if isSafeAreaConst #//iOS 11.1
        elmDiv.style.paddingTop = 'constant(safe-area-inset-top)'
        elmDiv.style.paddingLeft = 'constant(safe-area-inset-left)'
        elmDiv.style.paddingRight = 'constant(safe-area-inset-right)'
        elmDiv.style.paddingBottom = 'constant(safe-area-inset-bottom)'
      else #//iOS 11.2
        elmDiv.style.paddingTop = 'env(safe-area-inset-top)'
        elmDiv.style.paddingLeft = 'env(safe-area-inset-left)'
        elmDiv.style.paddingRight = 'env(safe-area-inset-right)'
        elmDiv.style.paddingBottom = 'env(safe-area-inset-bottom)'

      # //非表示にしてドキュメントに追加
      elmDiv.style.display = 'none'
      document.body.appendChild(elmDiv)

      # //計算後のsafe-area-inset-*を取得
      elmDivStyle = window.getComputedStyle(elmDiv)
      safeAreaInsetTop = parseInt(elmDivStyle.paddingTop)
      safeAreaInsetLeft = parseInt(elmDivStyle.paddingLeft)
      safeAreaInsetRight = parseInt(elmDivStyle.paddingRight)
      safeAreaInsetBottom = parseInt(elmDivStyle.paddingBottom)
      # console.log(
      #   'safeAreaInsetTop=' + safeAreaInsetTop,
      #   'safeAreaInsetLeft=' + safeAreaInsetLeft,
      #   'safeAreaInsetRight=' + safeAreaInsetRight,
      #   'safeAreaInsetBottom=' + safeAreaInsetBottom
      # )

      # //セーフエリアディスプレイか判断
      if window.navigator.userAgent.indexOf('iPhone') isnt -1

        # //iOSの場合、iPhoneXでない端末の場合でもステータスバーの20pxがinsetに設定されるので、このケースを除外する必要がある
        statusBarH = 20

        # //デバイスの回転によってどこにinsetが付くのかわからないので、４辺のどこかにinsetが設定されればセーフエリアディスプレイだとみなす
        if safeAreaInsetTop > statusBarH or safeAreaInsetLeft > statusBarH or safeAreaInsetRight > statusBarH or safeAreaInsetBottom > statusBarH
          flag = true
      else
        if safeAreaInsetTop > 0 or safeAreaInsetLeft > 0 or safeAreaInsetRight > 0 or safeAreaInsetBottom > 0
          flag = true

      # //ドキュメントから削除
      document.body.removeChild(elmDiv)

    # //デバッグログ
    # console.log('isSafeAreaDisplay=' + flag, 'isSafeAreaConst=' + isSafeAreaConst, 'isSafeAreaEnv=' + isSafeAreaEnv)

    return flag

  $('.js-fixed-contents').headroom()

  $(window).on('scroll',
    ()->
      isSafeAreaDisplay()

      if $(this).scrollTop() > $('.l-container').outerHeight() - window.innerHeight - $('.l-footer').outerHeight() + safeAreaInsetBottom
        $('.js-fixed-contents').addClass('is-bottom')
      else
        $('.js-fixed-contents').removeClass('is-bottom')
  )

  $('.tel').on('click',
    (e)->
      if not $('.p-fixed-tel').hasClass('is-active')
        $('.p-fixed-tel').addClass('is-active')
        $('.p-fixed-cv').addClass('is-active')
      else
        $('.p-fixed-tel').removeClass('is-active')
        $('.p-fixed-cv').removeClass('is-active')
  )
)
